import React from 'react';
import FactureZakPositionTool from '../components/FactureZakPositionTool';

const FactureZakTool: React.FC = () => {
  const pdfOptions = {
    'FactureZak.pdf': {
      url: '/pdfs/FactureZak.pdf',
      fields: {}, // Les champs sont définis dans FactureZakPositionTool
      firestoreDoc: 'facturesZAK', // Document Firestore spécifique pour les factures Zak
    },
  };

  const defaultPdfName = 'FactureZak.pdf';

  return (
    <FactureZakPositionTool pdfOptions={pdfOptions} defaultPdfName={defaultPdfName} />
  );
};

export default FactureZakTool;
